import { createApp } from "vue";
import App from "./App.vue";
import router, { initDynamicRoutes } from "./router";
import { UIC_AUTH_KEYS } from "./utils/auth";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";

// 创建应用并挂载路由
const app = createApp(App);
app.use(router);
app.use(ElementPlus, { locale: zhCn });

// 挂载应用
app.mount("#app");

// 初始化动态路由（异步，不阻塞首屏；与路由守卫共用同一 Promise）
setTimeout(async () => {
  const hasToken =
    localStorage.getItem(UIC_AUTH_KEYS.accessToken) ||
    sessionStorage.getItem(UIC_AUTH_KEYS.accessToken);
  if (!hasToken) return;

  try {
    await initDynamicRoutes();
  } catch (error) {
    console.error("动态路由初始化失败:", error);
  }
}, 0);
